import { UseQueryOptions } from '@tanstack/react-query';

import { Segment } from 'domains/segments/types';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths, SortDirection } from 'models/enums';
import { Folder } from 'models/types';

import QueryKeys from './keys';

export type PaginatedArchivedSegmentsResponse = {
    total: number;
    offset: number;
    limit: number;
    data: (Segment | Folder)[];
};

type UsePaginatedArchivedSegmentsParams = {
    options?: {
        searchTerm?: string;
        limit?: number;
        offset?: number;
        sortColumn?: string;
        sortDirection?: SortDirection;
    };
    reactQueryOptions?: UseQueryOptions<PaginatedArchivedSegmentsResponse, Error>;
};

const usePaginatedArchivedSegments = ({ options = {}, reactQueryOptions }: UsePaginatedArchivedSegmentsParams = {}) => {
    const { searchTerm, limit, offset, sortColumn, sortDirection } = options;

    const queryKey = QueryKeys.ARCHIVED_SEGMENTS_PAGINATED(searchTerm, offset, limit, sortColumn, sortDirection);

    const params: Record<string, string | number> = {};
    if (searchTerm?.trim()) {
        params.searchTerm = searchTerm.trim();
    }
    if (limit !== undefined) {
        params.limit = limit;
    }
    if (offset !== undefined) {
        params.offset = offset;
    }
    if (sortColumn && sortDirection) {
        params.sort = `${sortColumn}:${sortDirection}`;
    }

    const axiosOptions = Object.keys(params).length > 0 ? { params } : {};

    return useQuery<PaginatedArchivedSegmentsResponse>(
        queryKey,
        CuredApiPaths.SEGMENTS_ARCHIVED_PAGINATED,
        reactQueryOptions,
        axiosOptions
    );
};

export default usePaginatedArchivedSegments;
